export const API_BASE_URL = 'https://apisunsale.azurewebsites.net/api';
